export default __webpack_public_path__ + "static/to-top-5af88ae7337a6da8b79bb1e0c78e0a9a.svg";